import {Injectable} from '@angular/core'
import ELK, { ElkExtendedEdge, ElkNode } from 'elkjs/lib/elk.bundled.js'
import { IGraphData } from '../../models/graph-kn.model-interfaces'
import { from, Observable } from 'rxjs'
import { GraphKnDataService } from '../graph-kn.data.service'
import { BUSINESS_PROCESS_LAYER_ID } from '../../models/graph-kn.cm-api-models'
import { graphDefaultSettings } from '../../models/graph-kn.cm.model-const'
@Injectable({
  providedIn:'root'
})
export class ElkLayoutService {
  private elk = new ELK()
  private defaultSettings = graphDefaultSettings
  constructor(
    private knDataService : GraphKnDataService
  ) { }
  createElkLayout(graphData:IGraphData):Observable<Omit<ElkNode, "children"> & {children?: ElkNode[] | undefined;}> {
  let graphSettings = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)
    let children:ElkNode [] =  graphData.nodes.map(el=>{return {
      id:el.id,
      width:el.dimension?.width,
      height:el.dimension?.height
    }})
    let edges:ElkExtendedEdge [] =  graphData.edges.map(el=>{return {
      id:el.id||el.data.id,
      sources:[el.source],
      targets:[el.target]
    }})
    let orientationMap = new Map([
      ['TB','DOWN'],
      ['LR','RIGHT']
    ])
    let layoutOptions = {
        'elk.algorithm': graphSettings?.ranker||'layered',
        'elk.direction': orientationMap.get(graphSettings?.orientation||'')||'RIGHT',
        'elk.spacing.nodeNode': (graphSettings?.rankPadding||this.defaultSettings.rankPadding!)?.toString(),
        'elk.layered.spacing.edgeNodeBetweenLayers':( graphSettings?.nodePadding||this.defaultSettings.nodePadding!)?.toString(), 
        'elk.spacing.edgeNode': '20',
        'elk.layered.spacing.baseValue':'50',
        'elk.padding': '[top=80, left=100, bottom=50, right=10]' 
    };
    let dataForElkGraph:ElkNode = {
      id:'root',
      layoutOptions,
      children: children,
      edges: edges
    }
   return from(this.elk.layout(dataForElkGraph))
  }

  createElkLayout_BP_Links(graphData:IGraphData):Observable<Omit<ElkNode, "children"> & {children?: ElkNode[] | undefined;}> {
    let graphSettings = this.knDataService.layoutDagreSettings.get(BUSINESS_PROCESS_LAYER_ID)
      let bProcesses = graphData.nodes.filter(node=>node.nodeType === 'parentBP')
    let childrenWithGroups = bProcesses.map(bp=>{return {
        id:bp.id,
        layoutOptions: { 'elk.padding': '[top=30,left=20,bottom=10,right=20]'},
        children: graphData.nodes.filter(node=>node.parent === bp.id).map(el=>{return {
            id:el.id,
            width:el.dimension?.width,
            height:el.dimension?.height,
        }})
    }})
    let edges:ElkExtendedEdge [] =  graphData.edges.map(el=>{return {
      id:el.id!,
      sources:[el.source],
      targets:[el.target]
    }})
    let layoutOptions = {
        'elk.algorithm': 'layered',
        'elk.hierarchyHandling': 'INCLUDE_CHILDREN', 
        'elk.direction': 'RIGHT',

        'elk.spacing.nodeNode': (graphSettings?.rankPadding||this.defaultSettings.rankPadding!)?.toString(),
        'elk.layered.spacing.edgeNodeBetweenLayers':( graphSettings?.nodePadding||this.defaultSettings.nodePadding!)?.toString(), 
        'elk.spacing.edgeNode': '20',
        'elk.layered.spacing.baseValue':'50',
        'elk.padding': '[top=80, left=100, bottom=50, right=10]' 
    };
    
    let dataForElkGraph:ElkNode = {
      id:'root',
      layoutOptions,
      children: childrenWithGroups,
      edges: edges
    }
   return from(this.elk.layout(dataForElkGraph))
  }

}